/*
  Project Structure · Import wizard, Preview step — the file's warnings (BUG-010, owner decision 2026-10-04).

  A building needs a name: a manual structure save with a blank one is refused ("Building name is required"),
  but a file import keeps working and gives the building the placeholder name "Building". The import preview
  (POST …/execution-structure/import-preview) lists one warning per such building in `warnings` (strings), e.g.
  'Building row 2 of 4 in the file has no name — it will be imported as "Building". …'. This shows them; nothing
  is shown when there are none.

    <StructureImportWarnings warnings={preview.warnings} />
*/
import { TriangleAlert } from 'lucide-react';
import { formatNumber } from '@/lib/format';

const SHOWN = 8;

export function StructureImportWarnings({ warnings }) {
  const items = (Array.isArray(warnings) ? warnings : [])
    .map((item) => String(item ?? '').trim())
    .filter(Boolean);
  if (!items.length) return null;
  const more = items.length - SHOWN;
  return (
    <div className="flex items-start gap-3 rounded-xl border border-status-amber/40 bg-status-amber-bg px-3.5 py-3" role="status" data-testid="structure-import-warnings">
      <TriangleAlert className="mt-0.5 h-4 w-4 shrink-0 text-status-amber-ink" aria-hidden="true" />
      <div className="min-w-0 text-[13px] leading-snug text-ink-2">
        <p className="font-semibold text-ink">
          {items.length === 1 ? '1 warning' : `${formatNumber(items.length, { decimals: 0 })} warnings`} — the import still works
        </p>
        <ul className="mt-1 list-disc space-y-0.5 pl-4">
          {items.slice(0, SHOWN).map((item, index) => (
            // index keys: the same text can repeat (one line per building)
            <li key={index}>{item}</li>
          ))}
        </ul>
        {more > 0 ? <p className="mt-1 text-[12px] text-ink-3">and {formatNumber(more, { decimals: 0 })} more like these</p> : null}
      </div>
    </div>
  );
}

export default StructureImportWarnings;
